var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loading"},[_c('b-spinner',{staticClass:"m-5 spinner-main",attrs:{"label":"Loading...","variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }